<template>
    <div>
        <div class="question_title">
          <img v-if="is_required" style="width:18px;height:18px" src="../image/required.png">
          {{title}}
          <!-- {{index + 1}}. {{title}} -->
        </div>
        <table width="100%">
            <tr class="concent" style="background-color: #f6f6f6;">
                  <th class="title"></th>
                <div class="desc">
                    <div  class="title_desc">
                        <th v-for="item in options.matrix_columns" :key="item.option_id">{{item.title}}</th>
                    </div>
                </div>
            </tr>
            <tr class="concent" v-for="item in options.matrix_rows" :key="item.option_id">
                <th  class="title"><div>{{item.title}}</div></th>
                <div class="desc">
                    <van-radio-group :disabled="is_done" v-if="matrix_subtype === 'simple'" class="select_desc" v-model="radioData[item.option_id]">
                        <th v-for="item in options.matrix_columns" :key="item.option_id">
                            <van-radio :name="item.option_id"></van-radio>
                        </th>
                    </van-radio-group>
                    <van-checkbox-group :disabled="is_done" v-else-if="matrix_subtype === 'multiple'" class="select_desc" v-model="result[item.option_id]">
                        <th v-for="item in options.matrix_columns" :key="item.option_id">
                            <van-checkbox :name="item.option_id" shape="square"></van-checkbox>
                        </th>
                    </van-checkbox-group>
                </div>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
  data () {
    return {
      radio: '1',
      isWrite: false,
      questionData: {
        question_id: this.question_id,
        is_required: this.is_required,
        topic_id: this.topic_id,
        title: this.title,
        img_url: '',
        desc: '',
        options: { ...this.options }
      },
      radioData: {},
      result: {}
    }
  },
  props: {
    title: {
      type: String
    },
    options: {
      type: Object
    },
    index: {
      type: Number
    },
    is_required: {
      type: Boolean
    },
    topic_id: {
      type: Number
    },
    question_id: {
      type: Number
    },
    is_done: {
      type: Boolean
    },
    desc: {
      type: String
    },
    img_url: {
      type: String
    },
    jump_rules: {
      type: Object
    },
    matrix_subtype: {
      type: String
    }
  },
  mounted () {
    this.isMakeOut()
    this.isSequired()
  },
  methods: {
    // 用户已填写问卷后展示相关
    isMakeOut () {
      if (this.matrix_subtype === 'simple') {
        const obj = {}
        const answers = this.options.matrix_answers
        answers.forEach(item => {
          obj[item.row_id] = item.column_id
        })
        this.radioData = obj
      } else if (this.matrix_subtype === 'multiple') {
        const obj = {}
        const answers = this.options.matrix_answers
        answers.forEach(item => {
          obj[item.row_id] = []
        })
        answers.forEach(item => {
          obj[item.row_id].push(item.column_id)
        })
        this.result = obj
      }
    },
    // 用户选择数据加工
    selectData () {
      if (this.matrix_subtype === 'simple') {
        const radioData = this.radioData
        const arr = []
        for (const key in radioData) {
          const obj = {
            answer: true,
            row_id: +key,
            column_id: +radioData[key]
          }
          arr.push(obj)
        }
        this.questionData.options.matrix_answers = [...arr]
      } else if (this.matrix_subtype === 'multiple') {
        const result = this.result
        const arr = []
        for (const key in result) {
          result[key].forEach(item => {
            const obj = {
              answer: true,
              row_id: +key,
              column_id: +item
            }
            arr.push(obj)
          })
        }
        this.questionData.options.matrix_answers = [...arr]
      }
    },
    // 判断问卷是否为必填项
    isSequired () {
      if (!this.is_required) {
        this.isWrite = true
      } else {
        this.isWrite = false
      }
    }
  },
  // 监控填写数据
  watch: {
    radioData: {
      deep: true,
      handler () {
        this.selectData()
        var arr = Object.keys(this.radioData)
        if (arr.length === this.options.matrix_rows.length) {
          this.isWrite = true
        } else {
          this.isSequired()
        }
      }
    },
    result: {
      deep: true,
      handler () {
        this.selectData()
        const result = this.result
        for (const key in result) {
          if (result[key].length === 0) {
            this.isWrite = false
            break
          } else {
            this.isWrite = true
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.question_title{
    margin-bottom: 15px;
}
.concent{
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #000;
    // text-align: left;
    .title {
        background-color: #f6f6f6;
        width: 20%;
        div{
          height: 100%;
          width: 100%;
        }
    }
    .desc {
        width: 80%;
        margin: 10px;
        .title_desc{
            width: 100%;
            display: flex;
            justify-content: space-around;
        }
        .select_desc{
            display: flex;
            justify-content: space-around;
        }
    }
}
</style>
